export function formatIndianPriceWithComa(amount) {
  if (isNaN(amount) || amount === null) return "0";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: amount % 1 !== 0 ? 2 : 0, 
    maximumFractionDigits: 2
  }).format(amount);
}
